import { em } from 'polished'
import styled from 'styled-components'

import FirstBlockWrapper from 'components/_special/FirstBlockWrapper'
import DynamicImage from 'components/DynamicImage'

export const Article = styled.article`
  ${p => p.theme.mq.upLg} {
    max-width: 80%;
  }
`

export const FirstBlockWrapperStyled = styled(FirstBlockWrapper)`
  background-color: ${p => p.theme.colors.purpleHeart};
  color: ${p => p.theme.colors.white};
`

export const DynamicImageStyled = styled(DynamicImage)`
  max-width: ${em(400)};
  transform: translateX(${em(10)});

  ${p => p.theme.mq.upMd} {
    max-width: none;
    transform: none;
  }

  ${p => p.theme.mq.upLg} {
    transform: translate(0, ${em(23)});
  }
`
